import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgAdd = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path d="M11 11.5v-3h2v3h3v2h-3v3h-2v-3H8v-2z" fill={props.color} />
    <Path
      clipRule="evenodd"
      d="M24 12.5c0 6.627-5.373 12-12 12s-12-5.373-12-12S5.373.5 12 .5s12 5.373 12 12m-2.25 0c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75S6.615 2.75 12 2.75s9.75 4.365 9.75 9.75"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgAdd);
export default Memo;
